import React from 'react';
import { ILoginContextState } from './ILoginContextState';

export const LoginContext = React.createContext<ILoginContextState>({
    isLoggedIn: false,
    onTryLoginAsync: async (): Promise<boolean> => Promise.resolve(false),
    onTryLogoutAsync: async (): Promise<boolean> => Promise.resolve(false),
});
